export const pastEventStatusName = 'Réalisé';
export const incomingEventStatusName = 'Planifié';

export const newslettersUrl = 'https://toulouse-dataviz.notion.site/Newsletters-061ce66f47784394a664e0c9b758ea04';
export const collectionsUrl = 'https://toulouse-dataviz.notion.site/Collection-f0f34df72cfb4599be6ad9ae30be1d87';

export const discordLink = 'https://discord.gg/Ch23qScbpc';
export const mailLink = 'mailto:contact@toulouse-dataviz.fr';
export const twitterLink = 'https://twitter.com/tls_dataviz?lang=fr';
export const gitHubLink = 'https://github.com/ToulouseDataViz';
export const youtubeLink = 'https://www.youtube.com/channel/UCo64gnxLZs1xIN-Y0Bv_Hpg/about';
export const meetupLink = 'https://www.meetup.com/fr-FR/Meetup-Visualisation-des-donnees-Toulouse/';
export const linkedInLink = 'https://www.linkedin.com/company/toulouse-dataviz1/';
export const clubInscriptionLink = 'https://eepurl.com/g8tVZL';
